'use client';

import type { FC } from 'react';
import { cn } from '../../../../utils/cn';
import { stockSrc } from './model';

export const LockIcon: FC<{ size?: number; className?: string }> = ({ size = 14, className }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" className={className} aria-hidden>
    <path d="M12 2a5 5 0 0 0-5 5v3H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2h-1V7a5 5 0 0 0-5-5zm-3 5a3 3 0 1 1 6 0v3H9V7zm3 8a1.5 1.5 0 0 1 .75 2.8V19a.75.75 0 0 1-1.5 0v-1.2A1.5 1.5 0 0 1 12 15z" />
  </svg>
);

export const SkinSprite: FC<{ src?: string; weaponKey: string; width: number; locked?: boolean; className?: string }> = ({
  src, weaponKey, width, locked, className,
}) => (
  <img
    src={src ?? stockSrc(weaponKey)}
    alt=""
    draggable={false}
    className={cn('object-contain', locked && 'opacity-45 grayscale', className)}
    style={{ width, height: width * 0.4 }}
  />
);

export const PremiumTag: FC<{ className?: string }> = ({ className }) => (
  <span className={cn('rounded px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wide text-side-t ring-1 ring-side-t/40', className)}>
    Премиум
  </span>
);

export const LOCKED_HINT = 'Выдаётся администрацией';
